import Vue from 'vue'
import App from '../../views/App.vue'
import Router from 'vue-router'
import './monitor.js'
import routes from '@/router/index'
import 'ijijin-view/vue'
import 'moo-css-base'
import '@/assets/styles/base.less'
import { initStat } from '@/assets/js/common.js'

Vue.filter('formatRate', function (s) {
    if (s === null || s === undefined || s === '' || s === '--') {
        return '--'
    }
    return s + '%'
})

Vue.filter('formatProfit', function (s, flag = false, flag1 = false, flag2 = false) {
    if (s === null || s === undefined || s === '' || s === '--') {
        return '--'
    }
    let res = (flag2 && Number(s) >= 100) ? Number(s).toFixed(1) : Number(s).toFixed(2);
    if (flag1) {
        return s >= 0 ? `+${res}%` : `${res}%`;
    }
    return flag ? res + '%' : res;
})

Vue.use(hxmui, {
    themeMode: 'white',
    componentsConfig: {
        H5Video: {
            videojs: videojs,
        },
    },
});
_.getResources(['ijijinProtocol', 'ijijinStat'], () => {
    new Vue({
        router: new Router(routes),
        render: h => h(App),
    }).$mount('#app');
    initStat();
});
